<!-- <header>
  <div class="header">
    <dx-toolbar class="header-toolbar">
      <dxi-item location="before">
        <i (click)="onToggelMenue()" class="fa-solid fa-bars"></i>
      </dxi-item>


      <dxi-item *ngIf="menuToggleEnabled" location="before" widget="dxButton" cssClass="menu-button" [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
    </dxi-item>

      <dxi-item location="after" widget="dxButton" locateInMenu="auto">
        <dx-menu [dataSource]="data" displayExpr="nameAr" [showFirstSubmenuMode]="showSubmenuModes"
          orientation="horizontal" [hideSubmenuOnMouseLeave]="true" (onItemClick)="itemClick($event)">
        </dx-menu>
      </dxi-item>

      <dxi-item location="after" cssClass="header-logo-center">
        <img src="/assets/icons/ERPh.png" alt="Logo" style="height: 50px;" />
      </dxi-item>


      <dxi-item location="after" menuItemTemplate="themeSelector" [visible]="cdcsetting">
        <div *dxTemplate="let data of 'item'">
          <theme-selector></theme-selector>
        </div>
      </dxi-item>

      <dxi-item location="before" locateInMenu="auto" menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'menuItem'">
        <dx-button class="user-button authorization" width="210px" height="100%" stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>



      <dxi-item location="before" locateInMenu="auto">
        <div class="dx-field">
          <div class="dx-field-value">
            <dx-drop-down-button [splitButton]="false" [useSelectMode]="false" text={{Language|translate}} icon="globe"
              [items]="languageSettings" displayExpr="name" keyExpr="id"
              (onItemClick)="onItemClick($event)"></dx-drop-down-button>
          </div>
        </div>
      </dxi-item>






      



    </dx-toolbar>
  </div>

</header>


  <app-back-page></app-back-page>


<dx-popup [showTitle]="true" title="{{'content'|translate}}" [dragEnabled]="false" [hideOnOutsideClick]="true"
  [showCloseButton]="false" [(visible)]="popupVisible">
  <dxi-toolbar-item widget="dxButton" toolbar="top" location="after" [options]="closeButtonOptions">
  </dxi-toolbar-item>
  <dxo-position at="center" my="center" [of]="positionOf" collision="fit">
  </dxo-position>
  <dx-scroll-view width="100%" height="100%">
    <app-home-tab></app-home-tab>
  </dx-scroll-view>
</dx-popup>
 -->





<div class="flex-header">
  <div class="flex">
    <div>
      <i (click)="onToggelMenue()" class="fa-solid fa-bars cursor-pointer"></i>
    </div>

    <div class="parent-translation">
      <div class="translation" (click)="onToggelTranslation()">
        <i class="fa-solid fa-earth-asia"></i>
        <span>{{translation}}</span>
        <!-- <i class="fa-solid fa-sort-down"></i> -->
      </div>

      <div class="optionsTranslations" [ngClass]="{'opcity':toggeltranslation,'hide':!toggeltranslation}">
        <p (click)="ChangeLangauage('ar')" class="d-flex">
          <span><i class="fa-solid fa-flag"></i></span>
          <span>{{ "lang.ar" | translate }}</span>
        </p>

        <p (click)="ChangeLangauage('en')" class="d-flex">
          <i class="fa-solid fa-flag-usa"></i> 
          <span> {{ "lang.en" | translate }}</span>
        </p>
      </div>

    </div>

  </div>


  <div class="position-relative">
    <input dir="rtl" #value type="text" placeholder="Search ERP" (input)="Search($event)" />
    <i class="fa-solid fa-magnifying-glass"></i>
    <div class="content-search" *ngIf="popupsearch">
      <ul>
        <li (click)="onNavigationRoute(item,value)" class="flex-li" *ngFor="let item of data.navihationMenu">
          <span>{{getName(item)}}</span>
          <span><i [ngClass]="item.styleClass"></i></span>
        </li>
      </ul>
    </div>
  </div>

  <p></p>


  <div class="container-img" (click)="backHome()">
    <!-- <img src="assets/icons/logo-removebg-preview.png" alt="Logo" style="height: 50px;" /> -->
    <img [src]="logoUrl" alt="Logo" style="height: 50px;" />
  </div>




</div>


<app-back-page></app-back-page>